import { useEffect } from "react";
import workspace from "../../components/canvas/core/workspace";

const useWorkspaceIntl = (intl) => {
  useEffect(() => {
    if (!intl) return;
    workspace.setIntl(intl);
  }, [intl]);
};

export default useWorkspaceIntl;
